import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';

import { GoogleTagManagerService } from 'angular-google-tag-manager'

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, AfterViewInit {

  public env = environment

  constructor(
    private gtmService: GoogleTagManagerService,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }

  ngAfterViewInit(): void {
    this.loadReclameAquiSeal();
  }

  private loadReclameAquiSeal(): void {
    const container: HTMLElement | null = this.elementRef.nativeElement.querySelector('#ra-verified-seal');
    if (!container || document.getElementById('ra-embed-verified-seal')) {
      return;
    }

    const script: HTMLScriptElement = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.id = 'ra-embed-verified-seal';
    script.src = 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js';
    script.setAttribute('data-id', 'MTc5NzkxNjphenVsemluaGE=');
    script.setAttribute('data-target', 'ra-verified-seal');
    script.setAttribute('data-model', 'horizontal_2');
    this.renderer.appendChild(container, script);
  }

  onClickFaleConosco() {
    const gtmtag = {
      event: 'button-click',
      data: 'Fale-conosco',
      transactionId: 332950684
    };
    this.gtmService.pushTag(gtmtag);
  }

}
